export default __webpack_public_path__ + "static/media/msalLoginBG.35de3219.jpeg";